module.exports = __webpack_public_path__ + "static/media/2.e12a90a1.png";